import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { Toaster } from './components/Toaster';
import { TooltipProvider } from './components/Tooltip';
import { queryClient } from './lib/query';
import { ThemeProvider } from './lib/theme';
import { router } from './router';

export function App() {
  return (
    <ThemeProvider>
      <TooltipProvider>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
          <Toaster />
        </QueryClientProvider>
      </TooltipProvider>
    </ThemeProvider>
  );
}
